import React, { useState } from "react";
import NavbarTopHorizontal from "../navbar-horizontal/NavbarTopHorizontal";
import NavbarVertical from "../navbar-vertical/NavbarVertical";
import { Drawer, Grid } from "antd";
import { AnimatePresence, motion } from "framer-motion";
import coreFunctions from "src/common/utils/coreFunctions";
import MobileNavbar from "src/navbar-vertical/MobileVertical";

const AppLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const screens = Grid.useBreakpoint();

  const toggleDrawer = () => {
    setDrawerVisible((prev) => !prev);
  };

  return (
    <motion.div
      key="component-animation"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div
        style={{ display: "flex", height: "100vh", flexDirection: "column" }}
      >
        {/* Top Navbar */}
        <NavbarTopHorizontal toggleDrawer={toggleDrawer} />

        {!coreFunctions.isMobileDevice() ? (
          <div style={{ display: "flex", flex: 1 }}>
            {/* Vertical Navbar */}
            <NavbarVertical collapsed={collapsed} setCollapsed={setCollapsed} />
            <div
              style={{
                flex: 1,
                overflowY: "auto",
              }}
            >
              {children}
            </div>
          </div>
        ) : (
          <>
            <AnimatePresence mode="wait">
              {drawerVisible ? (
                <motion.div
                  key="navbar"
                  initial={{ x: "100%", opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  exit={{ x: "0%", opacity: 0 }}
                  transition={{ type: "tween", duration: 0.2 }}
                >
                  <MobileNavbar
                    drawerVisible={drawerVisible}
                    setDrawerVisible={setDrawerVisible}
                  />
                </motion.div>
              ) : (
                <motion.div
                  key="content"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.2 }}
                  style={{
                    flex: 1,
                    overflowY: "auto",
                  }}
                >
                  {children}
                </motion.div>
              )}
            </AnimatePresence>
          </>
        )}
      </div>
    </motion.div>
  );
};

export default AppLayout;
